export const PRODUCT_ACTION_TYPES = {
  LOAD_PRODUCT_SUCCESS: 'LOAD_PRODUCT_SUCCESS',
  LOAD_PRODUCT_LIST_SUCCESS: 'LOAD_PRODUCT_LIST_SUCCESS',
  LOAD_EX_PRODUCTS_SUCCESS: 'LOAD_EX_PRODUCTS_SUCCESS'
};
